module.exports = __webpack_public_path__ + "img/icon.14a8d2a4.png";